// UTF-8

document.addEventListener("DOMContentLoaded", function () {
	initAboutFeastTtl();
	initFixedMainReveal();
	if (window.innerWidth >= 768) {
		initFeastFxSlider();
		initFeastProductSlider();
		// initAboutHorizontalScroll();   // 横スクロール：一旦廃止
		// initTakumiCardsWheelScroll();  // 匠カードホイール：一旦廃止
	} else {
		initFeastFxSliderSp();
		initFeastContentsSpZoom();
	}
	initFeastSec02FadeIn();
	initAboutBgScroll();
});

/*----------------------------------------
▼ 1文字ずつゆっくり出現させる（画面内に入ったら発火）
----------------------------------------*/
function initAboutFeastTtl() {
	var selector = ".about_feast_ttl, .js-char-reveal";
	var elements = document.querySelectorAll(selector);
	if (!elements.length) return;

	var animated = new Set();

	var observer = new IntersectionObserver(
		function (entries) {
			entries.forEach(function (entry) {
				if (!entry.isIntersecting) return;
				var el = entry.target;
				if (animated.has(el)) return;
				animated.add(el);
				observer.unobserve(el);
				animateText(el);
			});
		},
		{
			root: null,
			rootMargin: "0px 0px -10% 0px",
			threshold: 0,
		}
	);

	for (var i = 0; i < elements.length; i++) {
		observer.observe(elements[i]);
	}
}

function animateText(element, onComplete) {
	var spans = element.getElementsByTagName("span");
	if (!spans.length) return;
	var delayMs = 75;
	for (var j = 0; j < spans.length; j++) {
		(function (index) {
			setTimeout(function () {
				spans[index].style.opacity = 1;
				if (onComplete && index === spans.length - 1) {
					onComplete();
				}
			}, index * delayMs);
		})(j);
	}
}

/*----------------------------------------
▼ fixed_main：スクロールで要素を順番に表示
----------------------------------------*/
function initFixedMainReveal() {
	if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;

	gsap.registerPlugin(ScrollTrigger);

	var section = document.querySelector(".fixed_main");
	var layer01 = document.querySelector(".fixed_main-layer01");
	var layer02Inner = document.querySelector(".fixed_main-layer02-inner");
	var img01 = document.querySelector(".fixed_main-layer02-img01");
	var img02 = document.querySelector(".fixed_main-layer02-img02");
	var img03 = document.querySelector(".fixed_main-layer02-img03");
	var img04 = document.querySelector(".fixed_main-layer02-img04");
	var img05 = document.querySelector(".fixed_main-layer02-img05");
	var img06 = document.querySelector(".fixed_main-layer02-img06");

	if (!section) return;

	var header = document.querySelector("header");
	var getHeaderHeight = function () {
		return header ? header.offsetHeight : 110;
	};

	var targets = [layer01, layer02Inner, img01, img02, img03, img04, img05, img06].filter(Boolean);
	if (!targets.length) return;

	gsap.set(layer01, { opacity: 0, y: 28 });
	gsap.set([layer02Inner, img01, img02, img03, img04, img05, img06].filter(Boolean), { opacity: 0, y: 80 });

	// layer01はページ読み込み時にフェードイン（スクロールでは上に流すのみ）
	if (layer01) {
		window.addEventListener("load", function () {
			gsap.to(layer01, { opacity: 1, y: 0, duration: 0.8, ease: "power2.out" });
		});
	}

	var layer02CharRevealDone = false;

	var tl = gsap.timeline({
		scrollTrigger: {
			trigger: section,
			start: function () {
				return "top " + getHeaderHeight() + "px";
			},
			end: "+=350%",
			pin: true,
			scrub: 1.5,
			onUpdate: function (self) {
				if (layer02Inner && self.progress >= 0.30 && !layer02CharRevealDone) {
					layer02CharRevealDone = true;
					animateText(layer02Inner);
				}
			},
		},
	});

	// fixed_mainの::beforeのopacityをスクロールで0→70%に（CSS変数で制御）
	tl.to(section, { "--fixed-main-before-opacity": 0.7, duration: 1, ease: "none" }, 0);

	// layer01を画面外へ（完了後に次を表示するため退場を先に完了させる）
	if (layer01) {
		tl.to(layer01, { y: "-100vh", duration: 0.12, ease: "none" }, 0.12);
	}
	// layer01が画面外に行ってから layer02 を表示（0.12 + 0.12 = 0.24 以降に開始）
	if (layer02Inner) {
		tl.fromTo(layer02Inner, { opacity: 0, y: 80 }, { opacity: 1, y: 0, duration: 0.12, ease: "power2.out" }, 0.28);
	}
	if (img01) {
		tl.fromTo(img01, { opacity: 0, y: 80 }, { opacity: 1, y: 0, duration: 0.12, ease: "power2.out" }, 0.34);
		tl.to(img01, { y: "-100vh", duration: 0.22, ease: "none" }, 0.78);
	}
	if (img02) {
		tl.fromTo(img02, { opacity: 0, y: 80 }, { opacity: 1, y: 0, duration: 0.12, ease: "power2.out" }, 0.42);
		tl.to(img02, { y: "-100vh", duration: 0.18, ease: "none" }, 0.82);
	}
	if (img03) {
		tl.fromTo(img03, { opacity: 0, y: 80 }, { opacity: 1, y: 0, duration: 0.12, ease: "power2.out" }, 0.50);
		tl.to(img03, { y: "-100vh", duration: 0.18, ease: "none" }, 0.86);
	}
	if (img04) {
		tl.fromTo(img04, { opacity: 0, y: 80 }, { opacity: 1, y: 0, duration: 0.12, ease: "power2.out" }, 0.58);
		tl.to(img04, { y: "-100vh", duration: 0.18, ease: "none" }, 0.90);
	}
	if (img05) {
		tl.fromTo(img05, { opacity: 0, y: 80 }, { opacity: 1, y: 0, duration: 0.12, ease: "power2.out" }, 0.66);
		tl.to(img05, { y: "-100vh", duration: 0.18, ease: "none" }, 0.94);
	}
	if (img06) {
		tl.fromTo(img06, { opacity: 0, y: 80 }, { opacity: 1, y: 0, duration: 0.12, ease: "power2.out" }, 0.74);
		tl.to(img06, { y: "-100vh", duration: 0.18, ease: "none" }, 0.98);
	}
}

/*----------------------------------------
▼ about_feast_fx：縦スクロール連動のページめくりスライダー（PCのみ）
右から次のページが重なるように表示される効果
----------------------------------------*/
function initFeastFxSlider() {
	if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;
	if (window.innerWidth < 768) return;

	gsap.registerPlugin(ScrollTrigger);

	var section = document.querySelector(".about_feast-sec01");
	var contentsSec01 = document.querySelector(".about_feast_contents-sec01");
	var sliderViewport = document.querySelector(".about_feast_fx_slider_viewport");
	var track = document.querySelector(".about_feast_fx_slider_track");
	var textWrap = document.querySelector(".about_feast_contents_fx-text");
	if (!section || !contentsSec01 || !sliderViewport || !track || !textWrap) return;

	var header = document.querySelector("header");
	var getHeaderHeight = function () {
		return header ? header.offsetHeight : 110;
	};

	var texts = textWrap.querySelectorAll(".about_feast_contents_fx-text-absolute");
	if (texts.length < 3) return;

	var text1 = texts[0];
	var text2 = texts[1];
	var text3 = texts[2];

	var slides = track.querySelectorAll("li");

	// 【ページめくり効果】トラックを重ね用コンテナに、スライドをabsoluteで積層
	gsap.set(track, {
		position: "relative",
		width: "100%",
		height: "100%",
		xPercent: 0,
		transformOrigin: "center center",
	});
	gsap.set(sliderViewport, { overflow: "hidden", perspective: 1000 });

	// 次のページが上に重なるように、後ろほど高いz-index
	slides.forEach(function (li, index) {
		gsap.set(li, {
			transformOrigin: "right center",
			position: "absolute",
			top: 0,
			left: 0,
			width: "100%",
			height: "100%",
		});
	});

	// 初期位置：クリップパスでスタック（各スライドは拡大状態からスタート）
	gsap.set(slides[0], {
		zIndex: 1,
		scale: 1.12,
		clipPath: "inset(0 0% 0 0)",
		WebkitClipPath: "inset(0 0% 0 0)",
	});
	gsap.set(slides[1], {
		zIndex: 2,
		scale: 1.12,
		clipPath: "inset(0 100% 0 0)", // 右側から徐々に開く
		WebkitClipPath: "inset(0 100% 0 0)",
	});
	gsap.set(slides[2], {
		zIndex: 3,
		scale: 1.12,
		clipPath: "inset(0 100% 0 0)",
		WebkitClipPath: "inset(0 100% 0 0)",
	});

	gsap.set([text1, text2, text3], { opacity: 0, y: 12, visibility: "hidden", zIndex: 0 });

	// タイミング（やや長めで滑らかに）
	var slide2FlipStart = 0.20;
	var slide2FlipDuration = 0.42;
	var slide3FlipStart = 0.55;
	var slide3FlipDuration = 0.42;
	var progressLi2Start = slide2FlipStart + slide2FlipDuration / 2;
	var progressLi3Start = slide3FlipStart + slide3FlipDuration / 2;
	var textOutDuration = 0.05;
	var textOutGap = 0.06;
	var text1OutStart = progressLi2Start - textOutGap - textOutDuration;
	var text2OutStart = progressLi3Start - textOutGap - textOutDuration;
	var textInDelay = 0.04;
	var textBlankGap = 0.02;
	var textShowDelay = 0.10; // テキスト表示を少し遅らせる

	var tl = gsap.timeline({
		scrollTrigger: {
			trigger: contentsSec01,
			start: function () {
				return "top " + getHeaderHeight() + "px";
			},
			end: "+=200%",
			pin: contentsSec01,
			scrub: 1.8,
			snap: {
				snapTo: [0, 0.5, 1],
				duration: { min: 0.35, max: 0.8 },
				ease: "power2.inOut",
			},
			invalidateOnRefresh: true,
		},
	});

	tl.fromTo(text1, { opacity: 0, y: 12, zIndex: 0 }, { opacity: 1, visibility: "visible", zIndex: 1, pointerEvents: "auto", y: 0, duration: 0.2, ease: "power1.out" }, 0.02 + textInDelay + textShowDelay);

	// 1枚目：拡大状態から元サイズへ
	tl.to(
		slides[0],
		{
			scale: 1,
			duration: 0.45,
			ease: "power1.inOut",
		},
		0
	);

	// 【1→2】2枚目が右側からクリップパスで水平に開く
	tl.fromTo(
		slides[1],
		{
			clipPath: "inset(0 100% 0 0)",
			WebkitClipPath: "inset(0 100% 0 0)",
		},
		{
			clipPath: "inset(0 0% 0 0)",
			WebkitClipPath: "inset(0 0% 0 0)",
			duration: slide2FlipDuration,
			ease: "power1.inOut",
		},
		slide2FlipStart
	);

	// 2枚目：拡大状態から元サイズへ
	tl.to(
		slides[1],
		{
			scale: 1,
			duration: 0.45,
			ease: "power1.inOut",
		},
		slide2FlipStart
	);

	// 【2→3】3枚目も同様に右側からクリップパスで水平に開く
	tl.fromTo(
		slides[2],
		{
			clipPath: "inset(0 100% 0 0)",
			WebkitClipPath: "inset(0 100% 0 0)",
		},
		{
			clipPath: "inset(0 0% 0 0)",
			WebkitClipPath: "inset(0 0% 0 0)",
			duration: slide3FlipDuration,
			ease: "power1.inOut",
		},
		slide3FlipStart
	);

	// 3枚目：拡大状態から元サイズへ
	tl.to(
		slides[2],
		{
			scale: 1,
			duration: 0.45,
			ease: "power1.inOut",
		},
		slide3FlipStart
	);

	tl.set(text1, { opacity: 0, visibility: "hidden", zIndex: 0, pointerEvents: "none" }, text1OutStart);
	tl.set(text1, { opacity: 0, visibility: "hidden", zIndex: 0 }, progressLi2Start - 0.001);
	tl.fromTo(text2, { opacity: 0, visibility: "hidden", zIndex: 0, y: 24 }, { opacity: 1, visibility: "visible", zIndex: 1, pointerEvents: "auto", y: 0, duration: 0.18, ease: "power1.out" }, progressLi2Start + textBlankGap + textShowDelay);
	tl.set(text2, { opacity: 0, visibility: "hidden", zIndex: 0, pointerEvents: "none" }, text2OutStart);
	tl.set(text2, { opacity: 0, visibility: "hidden", zIndex: 0 }, progressLi3Start - 0.001);
	tl.fromTo(text3, { opacity: 0, visibility: "hidden", zIndex: 0, y: 24 }, { opacity: 1, visibility: "visible", zIndex: 1, pointerEvents: "auto", y: 0, duration: 0.18, ease: "power1.out" }, progressLi3Start + textBlankGap + textShowDelay);
}

/*----------------------------------------
▼ about_feast_fx：SP時はスクロールで画像が横幅いっぱいまでズーム
----------------------------------------*/
function initFeastFxSliderSp() {
	if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;
	if (window.innerWidth >= 768) return;

	gsap.registerPlugin(ScrollTrigger);

	var contentsSec01 = document.querySelector(".about_feast_contents-sec01");
	var viewport = document.querySelector(".about_feast_fx_slider_viewport");
	var track = document.querySelector(".about_feast_fx_slider_track");
	if (!contentsSec01 || !viewport || !track) return;

	var header = document.querySelector("header");
	var getHeaderHeight = function () {
		return header ? header.offsetHeight : 88;
	};

	var viewportWidth = viewport.offsetWidth;
	var scaleToFull = viewportWidth > 0 ? window.innerWidth / viewportWidth : 1;

	gsap.set(track, { xPercent: 0, transformOrigin: "center center" });
	gsap.to(track, {
		scale: scaleToFull,
		ease: "none",
		scrollTrigger: {
			trigger: contentsSec01,
			start: function () {
				return "top " + getHeaderHeight() + "px";
			},
			end: "+=150%",
			pin: contentsSec01,
			scrub: 1.5,
		},
	});
}

/*----------------------------------------
▼ about_feast_product：縦スクロールに合わせて、横に流れる（PCのみ）
----------------------------------------*/
function initFeastProductSlider() {
	if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;
	if (window.innerWidth < 768) return;

	var section = document.getElementById("about_feast_product");
	var track = document.querySelector(".about_feast_product_track");
	if (!section || !track) return;

	// 最後の要素で止める（画面外に出さない）= トラック幅250%の80%移動
	var xPercent = -80;

	gsap.to(track, {
		xPercent: xPercent,
		ease: "none",
		scrollTrigger: {
			trigger: section,
			start: "top top",
			end: "+=150%",
			pin: true,
			scrub: 1.5,
			snap: function (progress) {
				if (progress > 0.65) return 1;
				return progress;
			},
		},
	});
}


/*----------------------------------------
▼ about_feast_contents_sp：スクロールで画像がズーム、拡大完了で次の要素へ（SPのみ）
----------------------------------------*/
function initFeastContentsSpZoom() {
	if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;
	if (window.innerWidth >= 768) return;

	gsap.registerPlugin(ScrollTrigger);

	var blocks = document.querySelectorAll(".about_feast_contents_sp .about_feast_contents-img");
	if (!blocks.length) return;

	var transitioned = [];

	var staggerPx = 80;

	blocks.forEach(function (block, index) {
		var img = block.querySelector("img");
		if (!img) return;

		var st = {
			trigger: img,
			start: index === 0 ? "top bottom" : "top bottom-=" + (index * staggerPx) + "px",
			end: "top 15%",
			scrub: 1.5,
			onUpdate: function (self) {
				if (self.progress < 0.98) return;
				if (transitioned[index]) return;
				if (index >= blocks.length - 1) return;
				transitioned[index] = true;
				var next = blocks[index + 1];
				if (next) {
					var nextImg = next.querySelector("img");
					var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
					var nextImgTop = nextImg
						? nextImg.getBoundingClientRect().top + scrollTop
						: next.getBoundingClientRect().top + scrollTop;
					var targetY = Math.max(0, nextImgTop - window.innerHeight);
					var startY = window.pageYOffset || document.documentElement.scrollTop;
					var startT = performance.now();
					var duration = 1200;

					function easeOutCubic(t) {
						return 1 - Math.pow(1 - t, 3);
					}
					function tick(now) {
						var elapsed = now - startT;
						var t = Math.min(elapsed / duration, 1);
						var y = startY + (targetY - startY) * easeOutCubic(t);
						window.scrollTo(0, y);
						if (t < 1) requestAnimationFrame(tick);
					}
					requestAnimationFrame(tick);
				}
			},
		};

		gsap.fromTo(
			img,
			{ scale: 0.8 },
			{
				scale: 1,
				ease: "none",
				scrollTrigger: st,
			}
		);
	});
}

/*----------------------------------------
▼ about_feast_contents-sec02：画像を右／左からフェードイン（開始時間をずらす）
----------------------------------------*/
function initFeastSec02FadeIn() {
	if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;

	gsap.registerPlugin(ScrollTrigger);

	var sec02Img = document.querySelector(".about_feast_contents-sec02-img");
	var sec02Img01 = document.querySelector(".about_feast_contents-sec02-img01");
	if (!sec02Img && !sec02Img01) return;

	if (sec02Img) {
		gsap.set(sec02Img, { opacity: 0, x: 60 });
		gsap.fromTo(
			sec02Img,
			{ opacity: 0, x: 60 },
			{
				opacity: 1,
				x: 0,
				duration: 0.8,
				ease: "power2.out",
				scrollTrigger: {
					trigger: sec02Img,
					start: "top bottom",
					once: true,
				},
			}
		);
	}
	if (sec02Img01) {
		gsap.set(sec02Img01, { opacity: 0, x: -60 });
		gsap.fromTo(
			sec02Img01,
			{ opacity: 0, x: -60 },
			{
				opacity: 1,
				x: 0,
				duration: 0.8,
				ease: "power2.out",
				scrollTrigger: {
					trigger: sec02Img01,
					start: "top bottom",
					once: true,
				},
			}
		);
	}
}

/*----------------------------------------
▼ about_feast-sec02 〜 about_takumi_introduction：縦スクロールで横に動く（PCのみ）
  匠カードが画面中央に来たらピン解除して次へ
  ※ 一旦廃止：呼び出しをコメントアウト済み
----------------------------------------*/
function initAboutHorizontalScroll() {
	return; // 廃止のため即 return
	// if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;
	// if (window.innerWidth < 768) return;
	// gsap.registerPlugin(ScrollTrigger);
	// var container = document.querySelector(".about_horizontal-scroll");
	// var track = document.querySelector(".about_horizontal-scroll_track");
	// var cards = document.querySelector(".about_takumi_introduction_cards");
	// if (!container || !track) return;
	// var header = document.querySelector("header");
	// var getHeaderHeight = function () { return header ? header.offsetHeight : 110; };
	// var slides = track.querySelectorAll(".about_feast-sec02, .about_takumi_introduction");
	// if (!slides.length) return;
	// var containerWidth = container.offsetWidth;
	// var cardsAtCenter = false;
	// var centerThreshold = 50;
	// function checkCardsAtCenter() {
	// 	if (cardsAtCenter) return;
	// 	if (!cards) return;
	// 	var stAnim = ScrollTrigger.getById("aboutHorizontalScrollAnim");
	// 	if (stAnim && stAnim.progress < 0.9) return;
	// 	var rect = cards.getBoundingClientRect();
	// 	var cardsCenterY = rect.top + rect.height / 2;
	// 	var viewportCenter = window.innerHeight / 2;
	// 	if (Math.abs(cardsCenterY - viewportCenter) <= centerThreshold) {
	// 		cardsAtCenter = true;
	// 		ScrollTrigger.refresh();
	// 	}
	// }
	// window.addEventListener("scroll", checkCardsAtCenter, { passive: true });
	// window.addEventListener("resize", checkCardsAtCenter);
	// gsap.to(slides, {
	// 	xPercent: -110 * (slides.length - 1),
	// 	ease: "none",
	// 	scrollTrigger: {
	// 		id: "aboutHorizontalScrollAnim",
	// 		trigger: container,
	// 		start: function () { return "top " + getHeaderHeight() + "px"; },
	// 		end: "+=" + containerWidth,
	// 		scrub: 1.5,
	// 		anticipatePin: 1,
	// 		invalidateOnRefresh: true,
	// 	},
	// });
	// ScrollTrigger.create({
	// 	id: "aboutHorizontalScrollPin",
	// 	trigger: container,
	// 	start: function () { return "top " + getHeaderHeight() + "px"; },
	// 	end: function () {
	// 		if (!cardsAtCenter) return "+=" + containerWidth * 5;
	// 		var st = ScrollTrigger.getById("aboutHorizontalScrollPin");
	// 		if (!st) return "+=" + containerWidth;
	// 		var scrollY = window.scrollY || document.documentElement.scrollTop;
	// 		return "+=" + Math.max(containerWidth, scrollY - st.start);
	// 	},
	// 	pin: true,
	// 	anticipatePin: 1,
	// 	invalidateOnRefresh: true,
	// });
}

/*----------------------------------------
▼ 匠カード：マウスホイールで横スクロール（PCのみ）
  ※ 一旦廃止：呼び出しをコメントアウト済み
----------------------------------------*/
function initTakumiCardsWheelScroll() {
	return; // 廃止のため即 return
	// var cards = document.querySelector(".about_takumi_introduction_cards");
	// if (!cards) return;
	// var targetScrollLeft = 0;
	// var rafId = null;
	// var smoothFactor = 0.12;
	// function tick() {
	// 	var el = cards;
	// 	var maxScroll = el.scrollWidth - el.clientWidth;
	// 	if (maxScroll <= 0) return;
	// 	targetScrollLeft = Math.max(0, Math.min(targetScrollLeft, maxScroll));
	// 	var current = el.scrollLeft;
	// 	var diff = targetScrollLeft - current;
	// 	if (Math.abs(diff) < 0.5) {
	// 		el.scrollLeft = targetScrollLeft;
	// 		rafId = null;
	// 		return;
	// 	}
	// 	el.scrollLeft = current + diff * smoothFactor;
	// 	rafId = requestAnimationFrame(tick);
	// }
	// var edgeThreshold = 50;
	// cards.addEventListener("wheel", function (e) {
	// 	var el = cards;
	// 	if (el.scrollWidth <= el.clientWidth) return;
	// 	var maxScroll = el.scrollWidth - el.clientWidth;
	// 	var atLeftEnd = el.scrollLeft <= edgeThreshold;
	// 	var atRightEnd = el.scrollLeft >= maxScroll - edgeThreshold;
	// 	if (e.deltaY > 0 && atRightEnd) return;
	// 	if (e.deltaY < 0 && atLeftEnd) return;
	// 	e.preventDefault();
	// 	targetScrollLeft = el.scrollLeft + e.deltaY;
	// 	targetScrollLeft = Math.max(0, Math.min(targetScrollLeft, maxScroll));
	// 	if (rafId == null) rafId = requestAnimationFrame(tick);
	// }, { passive: false });
}

/*----------------------------------------
▼ #about：スクロールに応じて背景色を徐々に濃く（薄い色→濃い色を連続補間）
----------------------------------------*/
function initAboutBgScroll() {
	var about = document.getElementById("about");
	if (!about) return;

	// 始まり #FAF8F5 → 徐々に #E4DED0 へ
	var startColor = "#FAF8F5";
	var darkColor = "#E4DED0";

	about.classList.add("js-about-bg-scroll");

	var layer = document.createElement("div");
	layer.id = "about_bg_layer";
	layer.setAttribute("aria-hidden", "true");
	layer.style.cssText =
		"position:fixed;inset:0;z-index:-1;pointer-events:none;background:" + startColor + ";";
	about.appendChild(layer);

	about.style.background = "transparent";

	function hexToRgb(hex) {
		hex = hex.replace(/^#/, "");
		if (hex.length === 3) {
			hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
		}
		var n = parseInt(hex, 16);
		return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
	}

	function rgbToHex(r, g, b) {
		return "#" + [r, g, b].map(function (x) {
			var h = Math.round(x).toString(16);
			return h.length === 1 ? "0" + h : h;
		}).join("");
	}

	function lerpColor(hexFrom, hexTo, t) {
		t = Math.max(0, Math.min(1, t));
		var a = hexToRgb(hexFrom);
		var b = hexToRgb(hexTo);
		var r = a.r + (b.r - a.r) * t;
		var g = a.g + (b.g - a.g) * t;
		var b_ = a.b + (b.b - a.b) * t;
		return rgbToHex(r, g, b_);
	}

	function getDocTop(el) {
		if (!el) return 0;
		return el.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop);
	}

	function updateBg() {
		var scrollY = window.scrollY || document.documentElement.scrollTop;
		var sec02 = document.querySelector(".about_feast_contents-sec02");
		var endSection = document.querySelector(".about_takumi_introduction");

		var progress = 0;

		if (sec02) {
			var sec02Top = getDocTop(sec02);
			var sec02Bottom = sec02Top + sec02.offsetHeight;

			// 背景変化開始位置：sec02 が画面下端に触れ始めるあたり
			var startBgScroll = sec02Top - window.innerHeight;
			// 元の色へ戻し終える位置：about_takumi_introduction の終わり（bottom）が画面下端に来るタイミング
			var endScroll;
			if (endSection) {
				var introTop = getDocTop(endSection);
				var introBottom = introTop + endSection.offsetHeight;
				endScroll = introBottom - window.innerHeight;
			} else {
				endScroll = document.documentElement.scrollHeight - window.innerHeight;
			}
			endScroll = Math.max(endScroll, sec02Bottom + 1);

			if (scrollY <= startBgScroll) {
				// sec02 より手前：常に元の色
				progress = 0;
			} else if (scrollY < sec02Bottom) {
				// sec02 が見えている間：FAF8F5 → E4DED0 へ暗くなっていく
				var inLen = Math.max(sec02Bottom - startBgScroll, 1);
				var tIn = (scrollY - startBgScroll) / inLen;
				tIn = Math.max(0, Math.min(1, tIn));
				progress = tIn;
			} else if (scrollY < endScroll) {
				// sec02 を過ぎたら：E4DED0 → FAF8F5 へゆっくり戻っていく（少しイージングで滑らかに）
				var outLen = Math.max(endScroll - sec02Bottom, 1);
				var tOut = (scrollY - sec02Bottom) / outLen;
				tOut = Math.max(0, Math.min(1, tOut));
				// 二乗カーブでゆっくり 1→0 へ（easeIn 的）
				var tOutEased = tOut * tOut;
				progress = 1 - tOutEased;
			} else {
				// endScroll 以降：完全に元の色に戻る
				progress = 0;
			}
		}

		progress = Math.max(0, Math.min(1, progress));
		layer.style.background = lerpColor(startColor, darkColor, progress);
	}

	updateBg();
	window.addEventListener("scroll", updateBg, { passive: true });
	window.addEventListener("load", updateBg);
}
